import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { AddPaymentChannelForm } from './AddPaymentChannelForm'

export const AddPaymentChannelCommand = (props: ActionButtonProps) => {
  const translate = useTranslate()

  const { tenantId, legalEntityId } = useHook(
    'routing.general.useLegalEntityParams',
  )()

  const actions = useHook('mutators.moneyOut.useAddPaymentChannelActions')({
    receiverId: legalEntityId,
    tenantId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  return (
    <CommandModalButton
      actionId="moneyOut.AddPaymentChannelCommandData"
      title={translate('action.addPaymentChannel.title')}
      commandDataForm={AddPaymentChannelForm}
      submit={submit}
      {...props}
    />
  )
}
